import styled from 'styled-components';
import { MASKED_TEXT_CLASS } from 'analytics/constants';
import { BOTTOM_NAVBAR_HEIGHT_VARIABLE } from 'components/navbars/BottomNavbar';
import type { AudioMessageTone } from './audioMessages';
import { TONE_SURFACES } from './toneSurfaces';

export type StatusBarTone = AudioMessageTone | 'searching';

const MESSAGE_TONE_CLASSES: Record<StatusBarTone, string> = {
  searching: 'border border-border bg-vantis-pastelblue text-foreground',
  info: TONE_SURFACES.accent,
  success: TONE_SURFACES.success,
  warning: TONE_SURFACES.warning,
  error: TONE_SURFACES.error,
};

// Screens with a fixed bottom bar publish its height; the message stacks above it.
export const StatusBarBox = styled.div.attrs<{ $tone: StatusBarTone }>(({ $tone }) => ({
  className: `fixed left-2 right-2 z-50 flex items-start justify-between gap-2 rounded-[10px] px-2.5 py-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring ${MESSAGE_TONE_CLASSES[$tone]}`,
}))<{ $tone: StatusBarTone }>`
  bottom: calc(var(${BOTTOM_NAVBAR_HEIGHT_VARIABLE}, 0px) + 0.5rem);
`;

export const StatusBarText = styled.div.attrs({
  className: 'flex items-start gap-2 min-w-0',
})``;

export const StatusBarContent = styled.div.attrs({
  className: 'min-w-0',
})``;

export const StatusBarTitle = styled.p.attrs({
  className: `text-sm font-semibold ${MASKED_TEXT_CLASS}`,
})``;

export const StatusBarDescription = styled.p.attrs({
  className: `text-sm opacity-70 ${MASKED_TEXT_CLASS}`,
})``;

export const StatusBarActions = styled.div.attrs({
  className: 'flex shrink-0 items-center gap-2',
})``;

const ACTION_BUTTON_CLASSES: Record<AudioMessageTone, string> = {
  info: 'border border-primary bg-white text-primary',
  success: 'border border-primary bg-white text-primary',
  warning: 'bg-primary text-primary-foreground',
  error: 'bg-primary text-primary-foreground',
};

export const StatusBarActionButton = styled.button.attrs<{ $tone: AudioMessageTone }>(
  ({ $tone }) => ({
    type: 'button',
    className: `flex h-8 items-center gap-1 rounded-lg px-2.5 text-xs font-medium hover:opacity-90 ${ACTION_BUTTON_CLASSES[$tone]}`,
  })
)<{ $tone: AudioMessageTone }>``;

export const StatusBarInlineAction = styled(StatusBarActionButton).attrs({
  className: 'mt-2',
})``;

export const StatusBarCloseButton = styled.button.attrs({
  type: 'button',
  className: 'flex size-6 items-center justify-center rounded-lg opacity-70 hover:opacity-100',
})``;
